import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "@/components/Reveal";

const points = [
  ["Customer", "Lead source, budget, priorities and previous interactions"],
  ["Offer", "Relevant pricing, availability, terms and approved information"],
  ["Objective", "The question and action most likely to move the lead forward"],
];

export default function Workflow() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [34, -34]);

  return (
    <section id="workflow" data-testid="workflow-section">
      <div className="wrap">
        <div className="label mono">The ThinkWire workflow</div>
        <h2 className="section-title">One system around the conversation</h2>
        <p className="section-copy">
          ThinkWire prepares the rep, assists in the moment and turns every completed call into
          action and intelligence.
        </p>
        <nav className="workflow-nav">
          <a href="#prepare" data-testid="workflow-nav-prepare">
            <span>01</span>Prepare before the call
          </a>
          <a href="#perform" data-testid="workflow-nav-perform">
            <span>02</span>Perform during the call
          </a>
          <a href="#progress" data-testid="workflow-nav-progress">
            <span>03</span>Progress after the call
          </a>
        </nav>

        <article className="phase" id="prepare" ref={ref}>
          <div className="phase-grid">
            <div>
              <div className="label mono">Prepare</div>
              <h3>Every rep starts with the full picture</h3>
              <p>
                ThinkWire combines customer context, relevant offer knowledge and a clear call
                objective into one action-ready brief.
              </p>
              <div className="phase-points">
                {points.map(([k, v]) => (
                  <div className="phase-point" key={k}>
                    <strong>{k}</strong>
                    <span>{v}</span>
                  </div>
                ))}
              </div>
            </div>
            <motion.div style={{ y }}>
              <Reveal className="brief-ui" data-testid="brief-ui">
                <div className="ui-head">
                  <div className="ui-person">
                    <div className="avatar">JD</div>
                    <div>
                      <b>John Doe</b>
                      <span>Sunrise Residency · 4 prior interactions</span>
                    </div>
                  </div>
                  <div className="intent">HIGH INTENT</div>
                </div>
                <div className="brief-body">
                  <div className="objective">
                    <small>Call objective</small>
                    <strong>Resolve the price concern and secure a site visit</strong>
                  </div>
                  <div className="brief-columns">
                    <div className="brief-block">
                      <small>Customer context</small>
                      <b>Budget and timeline</b>
                      <p>
                        ₹1.7–1.9 Cr budget. Wants possession within 18 months. Spouse joins the final
                        decision.
                      </p>
                    </div>
                    <div className="brief-block">
                      <small>Offer knowledge</small>
                      <b>Relevant inventory</b>
                      <p>
                        Unit B-1406 remains available. Construction-linked payment plan is approved
                        for discussion.
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            </motion.div>
          </div>
        </article>
      </div>
    </section>
  );
}
